import type { StaffSessionDto } from '@planuze/admin-contracts';
import { create } from 'zustand';

/* Metadata da sessão de staff em memória (ADR-0354). NUNCA persiste — o token real
   vive só no cookie HttpOnly; refresh re-hidrata via GET /v1/staff/me (§4.9). */
interface StaffSessionState {
  readonly session: StaffSessionDto | null;
  readonly setSession: (session: StaffSessionDto | null) => void;
  readonly clear: () => void;
}

export const useStaffSessionStore = create<StaffSessionState>((set) => ({
  session: null,
  setSession: (session) => set({ session }),
  clear: () => set({ session: null }),
}));
